import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  return (
    <header className="relative z-50">
      <nav
        className={`fixed top-0 left-0 right-0 transition-all duration-300 ${
          isScrolled
            ? 'bg-background-100/95 backdrop-blur-md'
            : 'bg-transparent'
        }`}
      >
        <div className="px-4 md:px-6">
          <div className="flex items-center justify-between h-16">
            <Link
              to="/"
              className="flex items-center gap-2 text-foreground-950 hover:text-primary-400 transition-colors whitespace-nowrap"
            >
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-primary-500"></i>
              </div>
              <span className="font-heading text-xl font-bold tracking-wide">麻花影院</span>
            </Link>

            <div className="hidden md:flex items-center gap-1">
              <Link
                to="/"
                className={`px-4 py-2 text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer ${
                  location.pathname === '/'
                    ? 'text-primary-500 bg-primary-500/10'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
                }`}
              >
                首页
              </Link>
              {categories.slice(0, 5).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer ${
                    location.pathname === `/category/${cat.slug}`
                      ? 'text-primary-500 bg-primary-500/10'
                      : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
              <Link
                to="/about"
                className={`px-4 py-2 text-sm rounded-lg transition-all whitespace-nowrap cursor-pointer ${
                  location.pathname === '/about'
                    ? 'text-primary-500 bg-primary-500/10'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
                }`}
              >
                关于我们
              </Link>
            </div>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-950 cursor-pointer"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="菜单"
            >
              <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        <div
          className={`md:hidden transition-all duration-300 overflow-hidden ${
            isMobileMenuOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <div className="bg-background-100/95 backdrop-blur-md px-4 pb-4 flex flex-col gap-1">
            <Link to="/" className="px-4 py-3 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-200 rounded-lg transition-all whitespace-nowrap cursor-pointer">
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-3 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-200 rounded-lg transition-all whitespace-nowrap cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="px-4 py-3 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-200 rounded-lg transition-all whitespace-nowrap cursor-pointer">
              关于我们
            </Link>
          </div>
        </div>
      </nav>
    </header>
  );
}